import cx from 'classnames';
import * as React from 'react';
import { LazyLoader } from '../LazyLoader/LazyLoader';
import { Asset, Props as AssetProps } from './Asset';
import styles from './Background.module.scss';

import { withTranslation, WithTranslation } from 'react-i18next';

type Props = AssetProps<HTMLElement> &
  WithTranslation & {
    tagName?: keyof React.ReactHTML;
  };

class Background extends Asset<HTMLElement, Props> {
  render() {
    const {
      autoHeight,
      autoWidth,
      imageHeight,
      imageWidth,
      fit,
      focus,
      tagName,
      asset,
      className,
      format,
      png8,
      children,
      style,
      t,
      tReady,
      ...props
    } = this.props;
    const hasChildren = children !== null && children !== undefined;
    const backgroundImage = this.assetUrl && `url(${this.assetUrl})`;
    return (
      <LazyLoader>
        {React.createElement(
          tagName || 'div',
          {
            ...props,
            ref: this.elRef,
            role: hasChildren ? props.role : 'img',
            'aria-label': this.alt ? this.alt : t('bg-image-alt-text'),
            alt: this.alt ? this.alt : t('bg-image-alt-text'),
            style: {
              ...style,
              backgroundImage,
            },
            className: cx(className, styles.background),
            'data-asset-id': asset && asset.sys && asset.sys.id,
          },
          children,
        )}
      </LazyLoader>
    );
  }
}

const TranslatedBackground = withTranslation()(Background);

export { TranslatedBackground as Background, Background as _Background };
